<script setup lang="ts">
import { SVGIcons, type SVGName } from "@/SVGs";
import { computed, type CSSProperties } from "vue";

interface Props {
  icon: SVGName;
  width: string;
  height: string;
  fill?: string;
  style?: Partial<CSSProperties>;
}

const props = defineProps<Props>();

const icon = computed(() => {
  const item = SVGIcons[props.icon];

  if (!item) {
    return null;
  }

  return item;
});
</script>

<template>
  <component
    v-if="icon"
    :is="icon"
    :width="width"
    :height="height"
    :fill="fill"
    :style="style"
  />
</template>
